import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DetectMethodChanges, DetectSetterChanges, isValidNumber} from '../utils';
import {CurrentQuoteRateStatus, QuoteRateLimiterService} from "./quote-rate-limiter.service";
import {
    QuoteRateThrottlingSettings,
} from "./cqrs-model";

@Component({
    selector: 'ets-quote-rate-limiter-component',
    templateUrl: 'quote-rate-limiter.component.html',
    styleUrls: ['quote-rate-limiter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteRateLimiterComponent implements OnInit ,OnDestroy {


    constructor(private readonly _changeDetector: ChangeDetectorRef,
                private readonly _quoteRateLimiterService: QuoteRateLimiterService
    ) {
    }

    get quoteRateDisplayValue() : string {

        const rate = this.visibleRateKind === 'Raw' ? this.quoteRate : this.throttledQuoteRate;

        if (!isValidNumber(rate)) {
            return 'N/A';
        }

        return rate + '';
    }

    quoteRate: number = -1;

    throttledQuoteRate = -1;

    currentMode: 'Mode 1' | 'Mode 2' | 'Mode 3' = 'N/A' as any;

    modeList = [
        'Mode 1',
        'Mode 2',
        'Mode 3',
    ];

    currentManualMode: string;

    tempSettings: QuoteRateThrottlingSettings = {};

    isPopupVisible: boolean;

    visibleRateKind : 'Raw' | 'Mode-based' = 'Raw';

    visibleRateKindList = ['Raw', 'Mode-based'];

    private _isPopupDataLoading: boolean = false;
    get isPopupDataLoading(): boolean {
        return this._isPopupDataLoading;
    }

    @DetectSetterChanges()
    set isPopupDataLoading(value: boolean) {
        this._isPopupDataLoading = value;
    }

    ngOnInit(): void {
        this._quoteRateLimiterService.start();
        this._quoteRateLimiterService.currentQuoteRate$.subscribe((data: CurrentQuoteRateStatus) => {
            this.quoteRate = data.rate;
            this.currentMode = data.mode as any;
            this.throttledQuoteRate = data.throttledRate;
            this._changeDetector.detectChanges();
        })
    }

    ngOnDestroy() {
        this._quoteRateLimiterService.stop();
    }

    @DetectMethodChanges({isAsync: true})
    async showPopup() {
        this.isPopupVisible = true;
        this.isPopupDataLoading = true;
        try {
            await this.loadThrottlingSettings();
        } finally {
            this.isPopupDataLoading = false;
        }
    }

    @DetectMethodChanges()
    onPopupClosed() {
        this.isPopupVisible = false;
    }


    @DetectMethodChanges()
    onCurrentModeManualChange($event: any) {

    }

    @DetectMethodChanges()
    onManualModeSwitchChanged($event: any) {
        this.tempSettings.manualMode = this.currentMode;
    }

    @DetectMethodChanges({isAsync: true})
    private async loadThrottlingSettings() {
        try {
            const data = await this._quoteRateLimiterService.getThrottlingSettings();

            this.tempSettings = data;

            this.tempSettings.manualMode = this.currentMode = data.currentMode;

            this.tempSettings.visibleRateKind = this.visibleRateKind;

        } catch  {

        }
    }

    async saveThrottlingSettings() {

        const settings: QuoteRateThrottlingSettings = {
            mode1Threshold: this.tempSettings.mode1Threshold,
            mode2Threshold: this.tempSettings.mode2Threshold,
            mode2Rate: this.tempSettings.mode2Rate,
            mode3Rate: this.tempSettings.mode3Rate,
            currentMode:  this.tempSettings.isManualModeSwitch ? this.tempSettings.manualMode as any : null,
            isManualModeSwitch: this.tempSettings.isManualModeSwitch,
        };

        await this._quoteRateLimiterService.saveSettings(settings);

        this.visibleRateKind = this.tempSettings.visibleRateKind;

        this.closePopup();
    }

    @DetectMethodChanges()
    closePopup() {
        this.isPopupVisible = false;
    }
}